import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { Coupon } from '../../models/inModels/Coupon';
import { AppComponent } from '../../app.component';
import { CouponService } from '../../services/coupon/coupon.service';
import { ConfirmationService, DataTable, LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { StorageService } from '../../services/system/storage.service';


@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.css']
})
export class CouponsComponent implements OnInit {
  key = 'CouponsComponent';
	coupons: Coupon[];
	globalFilter: string;
	loading = false;
	totalRecords: number;
	filteredRecords: number;
	rowEvent:LazyLoadEvent;
	rows: SelectItem[];
	msg: Message[];
	selectedRows: number;
  createCustomCode: string;
  constructor(
    public app: AppComponent,
		private router: Router,
		private route: ActivatedRoute,
		private confirmationService: ConfirmationService,
		private couponsService: CouponService,
		public storageService: StorageService
  ) { 
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
  }

  ngOnInit() {
  }

  
	loadLazy(event) {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;

		this.couponsService.search(event).subscribe(
			dataPager => {
				this.coupons = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.coupons = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

  changeRows(event) {
		this.loadLazy(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  goBack() {
		this.router.navigate(['/']);
	}

	create() {
		this.router.navigate(['/coupons/create']);
	}

	edit(coupon: Coupon) {
		this.router.navigate(['coupons/edit', coupon.Code]);
	}

	confirmDelete(coupon: Coupon, dt: DataTable) {
		this.confirmationService.confirm({
			message: `Do you want to delete the coupon <strong>${coupon.CodeFormatted}</strong>?`,
			header: 'Delete Confirmation',
			icon: 'fa fa-trash',
			accept: () => {
				this.loading = true;
				this.couponsService.delete(coupon.Code).subscribe(
					success => {
						this.loadLazy(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.msg = [];
						this.msg.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/coupons/coupons.component.ts